import type { AssignmentStatus, HomeworkReviewProgressResponse } from '@wx-weiqi/contracts';

export type HomeworkListTone = 'neutral' | 'blue' | 'amber' | 'green' | 'muted';
export interface HomeworkListStatus {
  readonly key: string;
  readonly label: string;
  readonly tone: HomeworkListTone;
}

export const STUDENT_HOMEWORK_STATUSES: Readonly<Record<AssignmentStatus, HomeworkListStatus>> = {
  ASSIGNED: { key: 'ASSIGNED', label: '未开始', tone: 'amber' },
  IN_PROGRESS: { key: 'IN_PROGRESS', label: '作答中', tone: 'blue' },
  SUBMITTED: { key: 'SUBMITTED', label: '待批改', tone: 'amber' },
  REVIEWED: { key: 'REVIEWED', label: '已批改', tone: 'green' },
  EXPIRED: { key: 'EXPIRED', label: '已过期', tone: 'muted' },
};

export const TEACHER_HOMEWORK_STATUSES: readonly HomeworkListStatus[] = [
  { key: 'UNREVIEWED', label: '未批改', tone: 'amber' },
  { key: 'PARTIAL', label: '部分已批改', tone: 'blue' },
  { key: 'REVIEWED', label: '已批改', tone: 'green' },
  { key: 'UNKNOWN', label: '进度未获取', tone: 'muted' },
];

export function teacherHomeworkListStatus(
  progress: HomeworkReviewProgressResponse['data'] | undefined,
): HomeworkListStatus {
  if (progress === undefined) return TEACHER_HOMEWORK_STATUSES[3]!;
  if (progress.fullyGraded) return TEACHER_HOMEWORK_STATUSES[2]!;
  return TEACHER_HOMEWORK_STATUSES[progress.reviewedAssignments > 0 ? 1 : 0]!;
}

export function studentHomeworkListAction(status: AssignmentStatus): string {
  switch (status) {
    case 'ASSIGNED':
      return '开始作答';
    case 'IN_PROGRESS':
      return '继续作答';
    case 'SUBMITTED':
      return '查看作答';
    case 'REVIEWED':
      return '查看批改结果';
    case 'EXPIRED':
      return '查看作业';
  }
}

/** Display the actual server timestamp in the platform's China time zone. */
export function homeworkListDate(value: string | null | undefined): {
  readonly date: string;
  readonly time: string;
} | null {
  if (!value || !Number.isFinite(Date.parse(value))) return null;
  const parts = new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date(value));
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((entry) => entry.type === type)?.value;
  return {
    date: `${part('year')}-${part('month')}-${part('day')}`,
    time: `${part('hour')}:${part('minute')}`,
  };
}
